import {styled} from "@mui/material/styles";
import {Box, Button, Typography} from "@mui/material";

import colors from "../../themes/colors";

export const StyledContainer = styled(Box)({
  height: '100%',
  padding: 5,
});

export const StyledActions = styled(Box)({
  textAlign: "center",
  marginTop: 5
});

export const StyledAgreeButton = styled(Button)({
  minWidth: 150,
  backgroundColor: colors.greenFifth,
  color: '#fff',
  borderRadius: 30,
  '&:disabled': {
    backgroundImage: "unset",
  }
});

export const StyledError = styled(Box)({
  color: '#f00',
  fontStyle: 'italic',
  fontFamily: "AvenirNext-DemiBold",
  fontWeight: 500,
});

export const StyledTypoCongratulations = styled(Typography)({
  fontFamily: "AvenirNext",
  fontWeight: 400,
  color: 'rgb(98, 98, 98)',
  margin: '8px 0px',
});
